import { useParams } from "react-router-dom";
import Template from "../../components/template";
import NavBtn from "./components/NavBtn";
import FtmToCustomer from "./ftmToCustomer/FtmToCustomer";
import { useState } from "react";
import InstafixToCustomer from "./instafixToCustomer/InstafixToCustomer";
import InstafixToFtm from "./instafixToFtm/InstafixToFtm";

const JobInvoices = () => {
    const { job_id } = useParams();
    const [invoiceType, setInvoiceType] = useState('INSTAFIX_TO_CUSTOMER_PAYMENT_INVOICE');

    return (
        <Template>
            <div className="container-fluid mt-2">
                <div className="row align-items-start flex-column">
                    <div className="col-lg-5 ms-3 col-sm-8">
                        <h3 className="mb-0 h4 font-weight-bolder">Invoice</h3>
                        <p className="mb-4">
                            View and manage all invoices associated with this job.
                        </p>
                    </div>
                    <div className="col-lg-6 col-sm-8">
                        <div className="nav-wrapper position-relative end-0">
                            <NavBtn invoiceType={invoiceType} setInvoiceType={setInvoiceType}/>
                        </div>
                    </div>
                </div>
            </div>

            {invoiceType === 'FTM_TO_CUSTOMER_PAYMENT_INVOICE' && <FtmToCustomer job_id={job_id}/>}
            {invoiceType === 'INSTAFIX_TO_CUSTOMER_PAYMENT_INVOICE' && <InstafixToCustomer job_id={job_id}/>}
            {invoiceType === 'INSTAFIX_TO_FTM_PAYMENT_INVOICE' && <InstafixToFtm job_id={job_id}/>}
        </Template>
    );
};

export default JobInvoices;